// Simplified version of classnames package of the same name
// Array-only of strings or objects and no nesting
const classNames = (
  classes: Array<string | Record<string, boolean>>,
): string => {
  const classList: string[] = [];
  const classMap: Record<string, boolean> = {};

  classes.forEach((c) => {
    if (typeof c === "string") {
      classList.push(c);
    } else {
      Object.assign(classMap, c);
    }
  });

  Object.entries(classMap).forEach(([c, bool]) => {
    if (bool) {
      classList.push(c);
    }
  });

  return classList.join(" ");
};

export default classNames;
